import React from "react";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Checkbox } from "antd";

type Props = {
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
  selected?: boolean;
  onSelectChange?: (checked: boolean) => void;
  showCheckbox?: boolean;
};

const iconStyle: React.CSSProperties = {
  fontSize: 18,
  cursor: "pointer",
};

const GlossaryActions: React.FC<Props> = ({
  onView,
  onEdit,
  onDelete,
  selected,
  onSelectChange,
  showCheckbox = false,
}) => {
  return (
    <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
      {showCheckbox && (
        <Checkbox
          checked={selected}
          onChange={(e) => onSelectChange?.(e.target.checked)}
        />
      )}
      <EyeOutlined
        style={{ ...iconStyle, color: "#1890ff" }}
        onClick={onView}
      />
      <EditOutlined
        style={{ ...iconStyle, color: "#52c41a" }}
        onClick={onEdit}
      />
      <DeleteOutlined
        style={{ ...iconStyle, color: "#ff4d4f" }}
        onClick={onDelete}
      />
    </div>
  );
};

export default GlossaryActions;
